import 'babel-polyfill';
import es6Promise from 'es6-promise';

import './element';

es6Promise.polyfill();
